import {useRefState} from '@startlibs/core'
import React, {useEffect, useMemo, useState} from 'react'
import _ from 'lodash/fp'
import {enums, Uploader2} from 'uploader-frontend'
import {jwtGetFetcher, jwtPostFetcher} from '../utils/authFetch'
import {getJwt} from '../hooks/useJwt'
import {getProviderJwt} from '../hooks/useProviderJwt'
import {useNotification} from '../components/Notifications'
import { getUploaderJwt } from '../hooks/useUploaderJwt';
import { getStorageHost } from '../hooks/useStorageHost';
import { using} from '@startlibs/utils'
import { downloadFiles, pdfIframeSrc, viewFileSrc } from './utils';
import { ADMIN, PATIENT } from '../enums/UserRoles';
import {lazyProviderInfo, lazyProviderInfoSec, lazyUserInfo} from '../components/WithProvider'
import { convertToCareQualityGender } from '../enums/GenderCarequality';
import { CountryRegionData } from 'react-country-region-selector';
import { EmptyMedicalRecordsList } from './RequestOverview'


const apiEndpoints = {
  dicomViewer:(studies) => Promise.resolve({viewerURL:getStorageHost()+`/view/records/${studies.filter(_.get('recordUID')).map(_.get("recordUID")).join("|")}?t=${getUploaderJwt()}`}),
  nonDicomViewer: (record) => getStorageHost()+`/view/record/${record.recordUID}?t=${getUploaderJwt()}`,
  // shortTokenUrl: (requestId) => jwtGetFetcher(getJwt())(`/api/shortDownloaderToken`,{requestId: requestId}),
  shortTokenUrl: (requestId) => {
    return requestId 
      ? jwtGetFetcher(getJwt())(`/api/shortDownloaderToken`,{requestId: requestId})
      : jwtGetFetcher(getJwt())(`/api/shortDownloaderToken`)},
  downloadRecord: (record) => getStorageHost()+`/download/record/${record.recordUID}?t=${getUploaderJwt()}`,
  storageHost: () => getStorageHost(),
  loadDownloadRecord: (record,filename) => record.nonCompliantFiles
  ? jwtGetFetcher(getUploaderJwt())(getStorageHost()+`/download/async/nonDicoms/${record.nonCompliantFiles.map(_.get("recordUID")).join("-")}`).then(({fileUID})=> ({url:() => getStorageHost()+`/download/file/${fileUID}?t=${getUploaderJwt()}${filename ? '&originalFilename='+encodeURIComponent(filename) : ""}`}))
  : jwtGetFetcher(getUploaderJwt())(getStorageHost()+`/download/async/${record.recordUID}`).then(({fileUID})=> ({url:() => getStorageHost()+`/download/file/${fileUID}?t=${getUploaderJwt()}${filename ? '&originalFilename='+encodeURIComponent(filename) : ""}`}))
  ,
  pdfIframeSrc: (record) => pdfIframeSrc(record),
  downloadFiles: (shortJwt, records) => {downloadFiles(shortJwt, records)},
  viewFileSrc: (shortJwt, recordId) => viewFileSrc(shortJwt, recordId),
  
}


const fileFields2 = ['fileName','fileExtension','fileType','fileSize','uid','description','docType','locationFormId']
export const RecordsManagerDirectMessage = ({caseRequest = {}, autoGrouping, uploaderRef, listMode, caseId, allowReorder, disabled, setMedicalRecords, setCaseRequest, patientInfo, canOpenWorklist, isPatient, role, mode, refreshUrl, 
  selectedDirectMessageRecords, setSelectedDirectMessageRecords,
  ...rest}) => {
  
  const [, setNotification] = useNotification()
  const userInfo = role === ADMIN ? lazyUserInfo.read() : {}
  const adminUserEmail = role === ADMIN ? userInfo?.login : ''
  lazyProviderInfo.read();
  const providerInfoSec = role === ADMIN ? lazyProviderInfoSec.read() : null
  const medicalRecordsStore = useRefState(() => (caseRequest.medicalRecords||[]).map((file) => ({...file,...file.info})), (prev,current) => setMedicalRecords(current))
  var studyUIDList = []
  
  const [linkedStudies, setLinkedStudiesb] = useState(studyUIDList);
  const [locations, setLocations] = useState([]);
  const recordsOnHiddenFiles = (caseRequest.group?.info?.find(group => group.id === "notclass")?.items || []).map(String)
  const filteredRecords = caseRequest.medicalRecords.filter(record => 
    record.format !== "DicomStudy" 
    && record.format !== "NonCompliantDicom" 
    && record.recordClass !== "Pathology"
    && record.recordClass !== "Radiology"
    && !recordsOnHiddenFiles.includes(String(record.id))
    && !record.quarantined
  )
  
  const filteredRecordsId = filteredRecords.map((file) => String(file.id));

  const normalGroups = caseRequest.group?.info?.filter(group => group.id !== "notclass") || [];
  const groupsWithFilteredItems = normalGroups.map(group => ({
    ...group,
    items: group.items.filter(item => filteredRecordsId.includes(String(item)))
  }));
  const finalGroups = groupsWithFilteredItems.filter(group => group.items.length > 0);
  const dob = caseRequest.patientInfo?.dob;
  let formattedDate = '';
  if (dob) {
    const parts = dob.split('-');
    if (parts.length === 3) {
      // Assuming the format is MM-DD-YYYY
      const month = parts[0].padStart(2, '0');
      const day = parts[1].padStart(2, '0');
      const year = parts[2];

      // Create the desired format YYYYMMDD
      formattedDate = `${year}${month}${day}`;
    }
  } 
  
  const getStateCode = (state, country) => {
    if(!state) return null
    if(!country) return state
    try{
      if(country === 'US' || country === 'USA' || country === 'United States' || country === 'United States of America'){
        return CountryRegionData
          .find(country => {
            return country[1] === 'US';
          })[2]
          .split("|")
          .find(st => st.split("~")[0] === state).split("~")[1];
      }else{

        return CountryRegionData
          .find(c => {
            return c[0] === country;
          })[2]
          .split("|")
          .find(st => st.split("~")[0] === state).split("~")[1];
      }
    }catch {
      return state
    }
  }

  const careQualityPatient = useMemo(() => ({
    birthDate: caseRequest.patientInfo?.dob,
    // family: caseRequest.patientInfo?.lastName,
    lastName: caseRequest.patientInfo?.lastName,
    firstName: caseRequest.patientInfo?.firstName,
    middleName: caseRequest.patientInfo?.middleName,
    // given: caseRequest.patientInfo?.firstName+" "+caseRequest.patientInfo?.middleName,
    gender: convertToCareQualityGender(caseRequest.patientInfo?.gender),
    addressLine: caseRequest.patientInfo?.address?.address,
    city: caseRequest.patientInfo?.address?.city,
    state: getStateCode(caseRequest.patientInfo?.address?.state, caseRequest.patientInfo?.address?.country),
    country: caseRequest.patientInfo?.address?.country,
    postalCode: caseRequest.patientInfo?.address?.zipCode
  }),[caseRequest.patientInfo])

  useEffect(() => {

    let refreshTimeout = -1

    // get medicarl record locations
    jwtGetFetcher(getJwt())(`/api/medicalRecordLocationForms`, {requestId:caseRequest.requestId})
      .then((response) => {
        setLocations(response.map(({id, medicalRecordLocationItem: {name}}) => ({id, name})))
      })

    return  () => {
      clearInterval(refreshTimeout)
      setCaseRequest(_.unset("medicalRecords"));
    }
    
  }, [])

  const setLinkedStudies = (lStudies,type,newStudy) =>{
    
    setLinkedStudiesb(lStudies);
    
    if(type == 'Add'){
      medicalRecordsStore.set(medicalRecordsStore.get().concat(newStudy));
      setMedicalRecords(medicalRecordsStore.get());
    }
  }

  const persistRecord = (record) => {
    medicalRecordsStore.set(_.unionBy(_.property('recordUID'), [record]))
    return Promise.resolve()
  }

  const persistGroups = useMemo(() => () => Promise.resolve(), [])

  const persistRecordInfo = (updatedRecord,currentInfo) => {

    const notesPromise = updatedRecord?.notes?.note !== currentInfo?.notes?.note
      ? jwtPostFetcher(getUploaderJwt())(getStorageHost()+`/record/${updatedRecord.recordUID}/notes`,{note:updatedRecord?.notes?.note}, {method: 'PUT'})
      : Promise.resolve()
    const infoPromise = (!currentInfo || currentInfo.docType !== updatedRecord.docType || currentInfo.description !== updatedRecord.description)
      ? jwtPostFetcher(getUploaderJwt())(getStorageHost()+"/medicalRecord/info/"+updatedRecord.recordUID,{..._.pick(fileFields2,updatedRecord),type:'NonDicomFile'},{method:"PUT"})
      : Promise.resolve()

    const metaPromise = !_.isEqual(updatedRecord?.metadata,currentInfo?.metadata)
      ? jwtPostFetcher(getUploaderJwt())(getStorageHost()+`/record/${updatedRecord.recordUID}/metadata`,updatedRecord?.metadata, {method: 'PUT'})
      : Promise.resolve()

    const statePromise = (updatedRecord?.state !== currentInfo?.state && currentInfo?.state)
      ? jwtPostFetcher(getUploaderJwt())(getStorageHost()+`/record/${updatedRecord.recordUID}/state`,updatedRecord?.state, {method: 'PUT'})
      : Promise.resolve()

    return Promise.all([notesPromise,infoPromise,metaPromise,statePromise])
      .then(() =>
        medicalRecordsStore.set(_.unionBy(_.property('recordUID'), [updatedRecord]))
      )
  }

  const removePersistedRecord = (recordUID) => {

    const MAX_DELETE_RECORDS =  window.MAX_DELETE_RECORDS || 1000;
    
    var removePromises = null
    var nonCompliantsObj = []

    if(recordUID === enums.MetaRecordType.ALL_NON_COMPLIANT_DICOM){
      using(medicalRecordsStore.get().filter(record => record.format === enums.RecordFormat.NonCompliantDicom))(nonCompliants => {
        
        _.map((item) => nonCompliantsObj.push({'recordUID': item.recordUID}),nonCompliants)
        const chunkedArray = _.chunk(MAX_DELETE_RECORDS, nonCompliants);    
        removePromises = chunkedArray.map(items => {
          if(items.length){
            return jwtPostFetcher(getUploaderJwt())(getStorageHost()+'/record/'+items.map(_.get('recordUID')).join("-"),undefined,{method:"DELETE"})
          }else{
            Promise.resolve({})
          }
        })
        
      })

      return Promise.all(removePromises).then(() => {
          medicalRecordsStore.set(_.differenceBy(_.property('recordUID'), medicalRecordsStore.get(),  nonCompliantsObj ))
      })

    }else{
      
      const removePromise = medicalRecordsStore.get().find(record => record.recordUID === recordUID)
        ? jwtPostFetcher(getUploaderJwt())(getStorageHost()+'/record/'+recordUID,undefined,{method:"DELETE"})
        : Promise.resolve(false)

      return removePromise.then(() =>
        medicalRecordsStore.set(_.differenceBy(_.property('recordUID'), _ , [{recordUID}]))
      )
    }
  }

  const removeSelectedRecords = (selectedRecords) => {

    const MAX_DELETE_RECORDS =  window.MAX_DELETE_RECORDS || 1000;
    
    const selectdRecordsObj = []
    _.map((item) => selectdRecordsObj.push({'recordUID': item}),selectedRecords)
    
    const chunkedArray = _.chunk(MAX_DELETE_RECORDS, selectedRecords);
    
    const removePromises =
      chunkedArray.map(items => {
        if(items.length){
          var chuckedSelectedRecordsObj = []
          _.map((item) => chuckedSelectedRecordsObj.push({'recordUID': item}),items)
          return jwtPostFetcher(getUploaderJwt())(getStorageHost()+'/record/'+items.map((item) => item).join("-"),undefined,{method:"DELETE"})
        }else{
          Promise.resolve(false)
        }
      }) 
    
    return Promise.all(removePromises).then(() =>
      medicalRecordsStore.set(_.differenceBy(_.property('recordUID'), medicalRecordsStore.get(),  selectdRecordsObj ))
    )
  }
 
  return <>
    <Uploader2
      listMode={listMode}
      downloadEnabled={caseRequest}
      disabled={disabled}
      jwt={getUploaderJwt}
      apiEndpoints={apiEndpoints}
      ref={uploaderRef}
      groups={finalGroups}
      appJwt={getUploaderJwt}
      persistRecord={persistRecord}
      persistRecordInfo={persistRecordInfo}
      removePersistedRecord={removePersistedRecord}
      removeSelectedRecords={removeSelectedRecords}
      persistGroups={persistGroups}
      setNotification={setNotification}
      medicalRecords={filteredRecords}
      role={isPatient ? PATIENT : role ? role : ADMIN}
      autoGrouping={autoGrouping}
      allowReorder={false} 
      canMoveGroup={false} 
      canAddGroup={false} 
      // Those are to open Radiology Worklist
      patientName={patientInfo?.firstName+' '+patientInfo?.lastName}
      linkedStudies={linkedStudies}
      setLinkedStudies={setLinkedStudies}
      canOpenWorklist={false}
      worklistViewerJwt={getJwt}
      providerJwt={getProviderJwt}
      withViewAllButton={false}
      downloadFiles={downloadFiles}
      mode={mode}
      requestId={caseRequest.requestId}
      refreshUrl={refreshUrl}
      caseId={caseId}
      locations={locations}
      adminUserEmail={role === ADMIN ? adminUserEmail : ''}
      eveAiSettings={providerInfoSec?.eveAiSettings}
      carequalityEnabled={false}
      careQualityPatient={careQualityPatient}
      dicomRouterOrigin={window.DICOM_ROUTER_ORIGIN || ''}
      canRouteDicoms={false}
      canCreatePacs={false}
      isSelectingRecordsDirectMessage={true}
      selectedDirectMessageRecords={selectedDirectMessageRecords}
      setSelectedDirectMessageRecords={setSelectedDirectMessageRecords}
    />
    {(!filteredRecords || !filteredRecords.length || filteredRecords.length === 0) && 
        <div style={{height: '260px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <EmptyMedicalRecordsList>
            No supported files found
          </EmptyMedicalRecordsList>
        </div>
      }
  </>
}